export const eventTypes = {
  all: "all",
  attending: "attending",
};

export const attendingType = {
  YES: "YES",
  NO: "NO",
};
